import { BsThreeDots } from 'react-icons/bs'

const trendsForYou = [
  {
    id: 1,
    location: 'Philippines',
    topic: 'Entertainment',
    postCount: 100000000,
    title: 'Youtube',
    href: 'https://www.youtube.com/',
  },
  {
    id: 2,
    location: null,
    topic: 'Music',
    postCount: 35555,
    title: 'Apple Music',
    href: 'https://music.apple.com/us/new',
  },
  {
    id: 3,
    location: 'Philippines',
    topic: 'Music',
    postCount: 1234,
    title: 'Spotify',
    href: 'https://open.spotify.com',
  },
  {
    id: 4,
    location: 'USA',
    topic: 'Technology',
    postCount: 1231234,
    title: 'Vercel',
    href: 'https://vercel.com',
  },
  {
    id: 5,
    location: 'USA',
    topic: 'Games',
    postCount: 11123234,
    title: 'World of Warcraft',
    href: 'https://worldofwarcraft.blizzard.com/en-us/',
  },
  {
    id: 6,
    location: 'Europe',
    topic: 'AI',
    postCount: 1234567,
    title: 'Chatgpt',
    href: 'https://chatgpt.com',
  },
  {
    id: 7,
    location: null,
    topic: null,
    postCount: 123456,
    title: 'X',
    href: 'https://x.com',
  },
  {
    id: 8,
    location: null,
    topic: null,
    postCount: 123456789,
    title: '#GenericTitle',
    href: '#',
  },
  {
    id: 9,
    location: null,
    topic: 'Technology',
    postCount: 1234,
    title: 'Github',
    href: 'https://github.com',
  },
  {
    id: 10,
    location: 'Philippines',
    topic: 'Technology',
    postCount: 999999999999999,
    title: '#ScrollingBugFix',
    href: '#',
  },
]

const SubBannerContainer = () => {
  return (
    <div>
      <div className="border-theme mt-[15px] rounded-2xl border">
        <div className="flex flex-col items-start">
          <h1 className="px-[15px] py-[10px] text-xl font-bold">
            Trends for you
          </h1>
          <p className="text-sub px-[15px] pb-[5px] text-sm font-light tracking-tighter">
            ***These are just links to some of the most used websites for
            display.
          </p>
          {trendsForYou.map((item, idx) => {
            return (
              <button
                key={idx}
                type="button"
                className="w-full cursor-pointer justify-start"
                onClick={() => {
                  if (item.href === '#') return
                  if (
                    confirm(`Are you sure you want to visit: ${item.href} ?`)
                  ) {
                    window.location.href = item.href
                  }
                }}
              >
                <div className="hover-sub relative flex-col px-[15px] py-[6px] text-left">
                  <span className="text-sub text-sm tracking-tighter">
                    {item.topic ? `${item.topic} • ` : ''}Trending
                    {item.location ? ` in ${item.location}` : ''}
                  </span>
                  <p className="text-sm font-bold">{item.title}</p>
                  <span className="text-sub text-sm tracking-tighter">
                    {item.postCount} posts
                  </span>
                  <div className="hover-sub-text absolute top-[5px] right-[5px] flex h-[30px] w-[30px] items-center justify-center rounded-full">
                    <BsThreeDots />
                  </div>
                </div>
              </button>
            )
          })}
          {/* <h1 className="text-blue hover-sub mb-[10px] w-full px-[15px] py-[10px] text-sm">
            Show more
          </h1> */}
        </div>
      </div>
      <div className="border-theme mt-[15px] rounded-2xl border">
        {' '}
        <div className="flex flex-col items-start">
          <h1 className="px-[15px] py-[10px] text-xl font-bold">
            Who to follow
          </h1>
          <p className="text-sub px-[15px] pb-[15px] text-sm font-light tracking-tighter">
            This feature is not yet available...
          </p>
        </div>
      </div>
    </div>
  )
}

export default SubBannerContainer
